// extracted by mini-css-extract-plugin
export default {"section3Wrapper":"Section3_section3Wrapper__xABe5","overlay":"Section3_overlay__dpDme","content":"Section3_content__uaLGt","ctaButton":"Section3_ctaButton__XRkp2"};